<template>
    <b-button
        pill variant="danger"
        @event="$emit('click')"
    >
        <slot><i class="fa fa-pencil-square"></i></slot>
    </b-button>
</template>

<script>
    export default {
        name: "ButtonEdit",
    }
</script>

<style scoped>

</style>
